import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface SplitTestProps {
  duplicateFlow: () => void;
  addFlow: () => void;
}

export default function SplitTest({ duplicateFlow, addFlow }: SplitTestProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  const Component = isDesktop ? Dialog : Drawer;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger className="flex h-10 items-center rounded-2xl border border-dashed border-black-300 px-4 text-button-sm lg:h-12 lg:px-6 lg:text-button-md">
        <PlusCircle size={20} weight="fill" className="-ml-3 mr-2.5" />
        {isDesktop ? "Create split test" : "Add flow"}
      </Trigger>
      <Content>
        <Title>Duplicate current flow?</Title>
        <Description className="mb-12">
          Do you want to copy your current flow or make a new one from scratch?
        </Description>

        <div className="flex justify-between gap-x-2.5">
          <Button
            variant="outline-black"
            onClick={() => {
              addFlow();
              setIsOpen(false);
            }}
            className="lg:flex-1"
          >
            Create new
          </Button>

          <Button
            onClick={() => {
              duplicateFlow();
              setIsOpen(false);
            }}
            className="lg:flex-1"
          >
            Duplicate flow
          </Button>
        </div>
      </Content>
    </Component>
  );
}
